/* eslint-disable @typescript-eslint/no-explicit-any */
import IconEdit from '@assets/icons/edit.svg?react';
import IconFilters from '@assets/icons/filters.svg?react';
import IconLimit from '@assets/icons/limit.svg?react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import {
 GridColDef,
 GridColumnMenu,
 GridColumnMenuProps,
 useGridApiContext,
} from '@mui/x-data-grid-premium';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import {
 Dispatch,
 MutableRefObject,
 SetStateAction,
 SyntheticEvent,
} from 'react';
import { useTranslation } from 'react-i18next';

import { CustomGridApi } from './types';

const LimitMenuEl = ({
 handleClick,
 itemName,
}: {
 handleClick: () => void;
 itemName: string;
}) => (
 <MenuItem onClick={handleClick} id="limit-modal">
  <ListItemIcon>
   <IconLimit />
  </ListItemIcon>
  <ListItemText>{itemName}</ListItemText>
 </MenuItem>
);

const FiltersMenuEl = ({
 handleClick,
 itemName,
}: {
 handleClick: () => void;
 itemName: string;
}) => (
 <MenuItem onClick={handleClick} id="limit-modal">
  <ListItemIcon>
   <IconFilters />
  </ListItemIcon>
  <ListItemText>{itemName}</ListItemText>
 </MenuItem>
);

const TranslationMenuEl = ({
 handleClick,
 itemName,
}: {
 handleClick: () => void;
 itemName: string;
}) => (
 <MenuItem onClick={handleClick} id="translation-modal">
  <ListItemIcon>
   <IconEdit />
  </ListItemIcon>
  <ListItemText>{itemName}</ListItemText>
 </MenuItem>
);

const CustomColumnMenu = (
 props: GridColumnMenuProps & {
  hideMenu: (event: SyntheticEvent<Element, Event>) => void;
  colDef: GridColDef;
  open: boolean;
  apiRef: MutableRefObject<GridApiPremium>;
  setLimitModalState: Dispatch<
   SetStateAction<{
    anchorElement: HTMLDivElement | null;
    colName: string;
   } | null>
  >;
  setFilterMenuState: Dispatch<
   SetStateAction<{
    anchorElement: HTMLDivElement | HTMLButtonElement | null;
    colName: string;
   } | null>
  >;
  setTranslationModalState: Dispatch<
   SetStateAction<{
    anchorElement: HTMLDivElement | null;
    colName: string;
   } | null>
  >;
 },
) => {
 const {
  hideMenu,
  colDef,
  apiRef,
  setLimitModalState,
  setFilterMenuState,
  setTranslationModalState,
  open,
 } = props;
 const { t } = useTranslation();
 return (
  <GridColumnMenu
   hideMenu={hideMenu}
   colDef={colDef}
   open={open}
   slots={{
    columnMenuPinningItem: null,
    columnMenuFilterItem: null,
    columnMenuColumnsItem: null,
    columnMenuLimitsItem: colDef.type === 'number' ? LimitMenuEl : null,
    columnMenuFiltersItem: FiltersMenuEl,
    columnMenuTranslationsItem: TranslationMenuEl,
   }}
   slotProps={{
    columnMenuFiltersItem: {
     displayOrder: 998,
     itemName: t('global.filters'),
     handleClick: (event: React.SyntheticEvent) => {
      const anchorElement = apiRef.current.getColumnHeaderElement(colDef.field);
      hideMenu(event);
      setFilterMenuState({ colName: colDef.field, anchorElement });
     },
    },
    columnMenuLimitsItem: {
     displayOrder: 999,
     itemName: t('global.limits'),
     handleClick: (event: React.SyntheticEvent) => {
      const anchorElement = apiRef.current.getColumnHeaderElement(colDef.field);
      hideMenu(event);
      setLimitModalState({ colName: colDef.field, anchorElement });
     },
    },
    columnMenuTranslationsItem: {
     displayOrder: 1000,
     itemName: t('global.translations'),
     handleClick: (event: React.SyntheticEvent) => {
      const anchorElement = apiRef.current.getColumnHeaderElement(colDef.field);
      hideMenu(event);
      setTranslationModalState({ colName: colDef.field, anchorElement });
     },
    },
   }}
  />
 );
};

const CustomColumnMenuWrapper = (props: GridColumnMenuProps) => {
 const apiRef = useGridApiContext() as MutableRefObject<CustomGridApi>;

 const { hideMenu, colDef, open } = props;
 return (
  <CustomColumnMenu
   hideMenu={hideMenu}
   colDef={colDef}
   apiRef={apiRef}
   setLimitModalState={apiRef.current.setLimitModalState}
   setFilterMenuState={apiRef.current.setFilterMenuState}
   setTranslationModalState={apiRef.current.setTranslationModalState}
   open={open}
  />
 );
};

export default CustomColumnMenuWrapper;
